module.exports = __webpack_public_path__ + "7ce328a8878b77c2bc2db367a9b7ea53.jpg";